var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconReceipt = function SvgIconReceipt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.125 9.375a1 1 0 0 1 1-1h9.75a1 1 0 1 1 0 2h-9.75a1 1 0 0 1-1-1M6.125 13.125a1 1 0 0 1 1-1h9.75a1 1 0 1 1 0 2h-9.75a1 1 0 0 1-1-1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.75 3.5A1.75 1.75 0 0 0 2 5.25V19.5a1 1 0 0 0 1.447.894L6 19.118l2.553 1.276a1 1 0 0 0 .894 0L12 19.118l2.553 1.276a1 1 0 0 0 .894 0L18 19.118l2.553 1.276A1 1 0 0 0 22 19.5V5.25a1.75 1.75 0 0 0-1.75-1.75zM4 17.882V5.5h16v12.382l-1.553-.776a1 1 0 0 0-.894 0L15 18.382l-2.553-1.276a1 1 0 0 0-.894 0L9 18.382l-2.553-1.276a1 1 0 0 0-.894 0z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconReceipt;